import remarkGfm from 'remark-gfm'

/**
 * Markdown plugin wiring for rendering LLM-authored bot answers.
 *
 * Mirrors the brist-frontend pipeline (react-markdown + remark-gfm) so model
 * output looks the same across Antire frontends, with one deliberate omission:
 * the KaTeX math plugins (remark-math + rehype-katex + katex) are NOT included.
 * OTilie's domain (orthopedics, HMS, TQM docs) essentially never contains math,
 * and KaTeX adds a chunky CSS/font payload. See VC-753.
 *
 * Module-scope constant so every <ReactMarkdown> gets a stable plugin-array
 * reference — a fresh inline array on each render would defeat react-markdown's
 * memoization.
 */
export const remarkPlugins = [remarkGfm]
